<template>
  <div>
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on }">
        <v-btn color="error" v-on="on" :disabled="loading">
          <v-icon left>mdi-account-arrow-right-outline</v-icon>{{$t('userDeletionButton.delete')}}
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="headline" primary-title>{{$t('userDeletionButton.dialog-title')}}</v-card-title>

        <v-card-text>{{$t('userDeletionButton.confirm-question')}}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="performDeletion()" :loading="loading">
            <v-icon>mdi-delete</v-icon>{{$t('userDeletionButton.confirm')}}
          </v-btn>
          <v-btn class="primary" text @click="close()">
            <v-icon left>mdi-close</v-icon>{{$t('common.cancel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { MUTATION_LOGOUT, MUTATION_RAISE_NOTIFICATION } from "@/plugins/store";

export default {
  name: "UserDeletionButton",
  data: function() {
    return {
      loading: false,
      dialog: false
    };
  },
  methods: {
    performDeletion() {
      this.loading = true;
      this.$api
        .deleteMyAccount()
        .then(() => {
          this.loading = false;
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            type: "success",
            message: this.$t('userDeletionButton.deletion-confirmed')
          });
          this.$store.commit(MUTATION_LOGOUT);
          this.$router.push("/");
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
    },
    close() {
      this.dialog = false
    }
  }
};
</script>